<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="false"
    :showCancelBtn="false"
    class="history-reward"
    width="70%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
    @opened="handleOpen"
    top="5vh"
  >
    <template slot="title">
      {{ title }}
    </template>

    <tg-layout ref="layout" :headerHeight="100">
      <template slot="header" >
        <tg-amount-bar
          ref="amount"
          :columns="currentAmountColumns"
          :row="amountData"
        ></tg-amount-bar>
      </template>
      <tg-table
        ref="table"
        :columns="currentColumns"
        :proxy="proxy"
        align="center"
        :fit="true"
        showPagination
        showSummary
        :summary-method="parseSummary"
        @on-loaded="handleLoaded"
      >
        <template slot="betId" slot-scope="scope">
          <tg-bet-id :row="scope.row"></tg-bet-id>
        </template>

        <template slot="source_type" slot-scope="scope">
          <span :class="['text-' +  scope.row.source_type]">
              {{ $t("component.label.source_type." + scope.row.source_type) }}
          </span>
        </template>

        <template slot="betContent" slot-scope="scope">
          <tg-bet-content v-if="scope.row.source_type == 'tg'" :row="scope.row"></tg-bet-content>
          <third-party-saba-bet-content v-else-if="
              ((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
              (scope.row.content_type == 2 || scope.row.content_type == 5))
              || (scope.row.source_type.includes('sport') && scope.row.serial_type == 1) //serial_type == 1 非串關
            "
            :row="scope.row"></third-party-saba-bet-content>
          <third-party-saba-parlay-bet-content v-else-if="((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') && (scope.row.content_type == 3 || scope.row.content_type == 4))" :row="scope.row" @on-click="handlePublicParlayDialog(scope.row)"></third-party-saba-parlay-bet-content>
          <third-party-saba-parlay-bet-content
            v-else-if="
              (((scope.row.source_type != 'saba' && scope.row.source_type != 'sabawhite_sport') && scope.row.source_type.includes('sport'))) 
            "
            :row="scope.row"
            @on-click="handlePublicParlayDialog(scope.row)"
          ></third-party-saba-parlay-bet-content>
          <third-party-public-bet-content
            v-else
            :row="scope.row"
          ></third-party-public-bet-content>
        </template>

        <template slot="decimal" slot-scope="scope">
          <tg-decimal v-bind="scope"></tg-decimal>
        </template>
      </tg-table>
    </tg-layout>
  </tg-dialog>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgBetContent from "@/components/slot/TgBetContent";
import TgDecimal from "@/components/slot/TgDecimal";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgBetId from "@/components/slot/TgBetId";
import TgDialog from "@/components/dialog/TgDialog.vue";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.accounts.profit;

export default {
  inheritAttrs: false,
  components: {
    TgLayout,
    TgTable,
    TgBetContent,
    TgDecimal,
    TgAmountBar,
    TgBetId,
    TgDialog,
  },
  data() {
    return {
      columns: [],
      amountColumns: [],
      amountData: {},
      proxy: api.getDetail,
      visible: false,
      source_type:""
    };
  },
  props: {
    dialogInfo: Object,
  },
  computed: {
    title() {
      return this.dialogInfo ? this.dialogInfo.title : "";
    },
    currentColumns() {
      return this.dialogInfo.detailColumns;
    },
    currentAmountColumns() {
      if (this.dialogInfo.amountColumns.length == 0) {
        return [];
      }

      return this.dialogInfo.amountColumns;
    },
  },
  created() {
    
  },
  methods: {
    handleOpen() {
      this.$refs.table.doLayout();
      this.$refs.table.init(this.dialogInfo);
    },
    parseSummary({ data }) {
      return summary(
        this.currentColumns,
        data,
        this.$t("component.table.summary"),
        3
      );
    },
    handleLoaded(response) {
      if (response.amountData && !("length" in response.amountData)) {
        this.amountData = response.amountData;
      }
    },
    showDialog() {
      this.visible = true;
    },
  },
};
</script>
